import axios from 'axios';
const instance = axios.create({
    baseURL: 'https://bck-expert.e-solutions-rdc.com/api/v1'
});
export default instance;